// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"33805aea","703":"889cdc77"}[chunkId] + ".chunk.js";
};